import { cn } from "@/lib/utils";

export const Shimmer = ({ className, style }) => <div className={cn("pk-shimmer", className)} style={style} aria-hidden="true" />;

/** Card width classes are shared with MovieCard so skeletons match 1:1. */
export const ROW_CARD_W = "w-[40vw] xs:w-[36vw] sm:w-[27vw] md:w-[21vw] lg:w-[16.5vw] xl:w-[14.2vw] 3xl:w-[12.5vw] max-w-[250px]";
export const GRID_COLS = "grid grid-cols-2 gap-x-3 gap-y-6 xs:gap-x-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 3xl:grid-cols-7";

export function MovieCardSkeleton({ inRow = false }) {
  return (
    <div className={cn(inRow && ROW_CARD_W, inRow && "shrink-0")} data-testid="movie-card-skeleton">
      <Shimmer className="aspect-[2/3] w-full rounded-[20px]" />
      <Shimmer className="mt-3 h-[14px] w-4/5 rounded-full" />
      <Shimmer className="mt-2 h-[11px] w-1/2 rounded-full" />
    </div>
  );
}

export function RowSkeleton({ count = 8, title = true }) {
  return (
    <section className="py-4" aria-busy="true" aria-label="Yuklanmoqda">
      <div className="pk-container">{title && <Shimmer className="mb-4 h-[20px] w-44 rounded-full" />}</div>
      <div className="pk-bleed flex gap-3 overflow-hidden sm:gap-4">
        {Array.from({ length: count }).map((_, i) => (
          <MovieCardSkeleton key={i} inRow />
        ))}
      </div>
    </section>
  );
}

export function GridSkeleton({ count = 12 }) {
  return (
    <div className={GRID_COLS} aria-busy="true" data-testid="grid-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <MovieCardSkeleton key={i} />
      ))}
    </div>
  );
}

export const SearchSkeleton = () => <GridSkeleton count={12} />;

export function HeroSkeleton() {
  return (
    <section className="relative h-[78svh] min-h-[520px] max-h-[860px] w-full overflow-hidden" data-testid="hero-skeleton" aria-busy="true">
      <Shimmer className="absolute inset-0" />
      <div className="pk-fade-bottom absolute inset-0" />
      <div className="pk-container absolute inset-x-0 bottom-[12%]">
        <Shimmer className="h-5 w-28 rounded-full" />
        <Shimmer className="mt-4 h-12 w-[70%] max-w-[520px] rounded-[14px]" />
        <Shimmer className="mt-4 h-4 w-60 rounded-full" />
        <Shimmer className="mt-3 h-4 w-[80%] max-w-[480px] rounded-full" />
        <div className="mt-6 flex gap-3">
          <Shimmer className="h-12 w-44 rounded-[16px]" />
          <Shimmer className="h-12 w-36 rounded-[16px]" />
        </div>
      </div>
    </section>
  );
}

export function MovieDetailSkeleton() {
  return (
    <div data-testid="movie-detail-skeleton" aria-busy="true">
      <div className="relative h-[52svh] min-h-[340px] w-full">
        <Shimmer className="absolute inset-0" />
        <div className="pk-fade-bottom absolute inset-0" />
      </div>
      <div className="pk-container -mt-40 flex flex-col gap-6 md:flex-row md:items-end">
        <Shimmer className="mx-auto aspect-[2/3] w-[46vw] max-w-[260px] rounded-[22px] md:mx-0" />
        <div className="flex-1 space-y-3">
          <Shimmer className="h-10 w-2/3 rounded-[12px]" />
          <Shimmer className="h-4 w-1/3 rounded-full" />
          <Shimmer className="h-4 w-full max-w-[560px] rounded-full" />
          <Shimmer className="h-4 w-4/5 max-w-[480px] rounded-full" />
        </div>
      </div>
    </div>
  );
}
